import React, { useEffect, useState } from 'react';
import { Info } from 'lucide-react';
import { fetchText } from '../utils/api';

/**
 * The About Us Page component, providing information about the website.
 */
const AboutUsPage = () => {
  const [aboutUsText, setAboutUsText] = useState('');
  const [aboutDmText, setAboutDmText] = useState('');
  const dmImageUrl = `/${process.env.REACT_APP_TITLE}/DM.png`;

  useEffect(() => {
    document.title = `${process.env.REACT_APP_TITLE} - About Us`;

    const getText = async () => {
      try {
        const aboutUs = await fetchText('_about/info.txt');
        setAboutUsText(aboutUs);
        const aboutDm = await fetchText('_aboutDM/info.txt');
        setAboutDmText(aboutDm);
      } catch (error) {
        console.error("Error fetching text:", error);
      }
    };

    getText();
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section id="about" className="bg-card-background p-6 md:p-8 rounded-xl shadow-lg mb-8 flex flex-col md:flex-row">
      {/* Desktop category sidebar */}
      <nav className="hidden md:block md:w-1/4 lg:w-1/5 p-4 md:border-r border-border-light sticky top-0 self-start">
        <ul className="space-y-2">
          <li>
            <button
              onClick={() => scrollToSection('about-us')}
              className="text-primary-dark hover:text-primary-light font-semibold transition duration-300 text-left w-full"
            >
              About Us
            </button>
          </li>
          <li>
            <button
              onClick={() => scrollToSection('about-dm')}
              className="text-primary-dark hover:text-primary-light font-semibold transition duration-300 text-left w-full"
            >
              About Dilnavaz Mehta
            </button>
          </li>
        </ul>
      </nav>

      <div className="w-full md:w-3/4 lg:w-4/5 md:pl-8 md:mt-0">
        {/* Mobile category menu */}
        <nav className="block md:hidden mb-6 border border-border-light bg-white rounded-lg shadow mb-10">
          <ul className="flex flex-col gap-2 px-4 py-4 justify-center">
            <li>
              <button
                onClick={() => scrollToSection('about-us')}
                className="w-full text-primary-dark hover:text-primary-light font-semibold transition duration-300 text-center px-3 py-1 border border-border-light rounded-lg hover:bg-background-light"
              >
                About Us
              </button>
            </li>
            <li>
              <button
                onClick={() => scrollToSection('about-dm')}
                className="w-full text-primary-dark hover:text-primary-light font-semibold transition duration-300 text-center px-3 py-1 border border-border-light rounded-lg hover:bg-background-light"
              >
                About Dilnavaz Mehta
              </button>
            </li>
          </ul>
        </nav>

        <div id="about-us" style={{ scrollMargin: '20px' }}>
          <h2 className="text-3xl md:text-4xl font-bold text-primary-dark mb-6 border-b-2 border-border-light pb-2 flex items-center">
            <Info className="w-7 h-7 mr-2" /> About Us
          </h2>
          <div>
            {aboutUsText.split('\n').map((line, index) => (
              <p key={index} className="text-lg text-text-dark">
                {line.trim() === '' ? <br /> : line}
              </p>
            ))}
          </div>
        </div>

        <div id="about-dm" className="mt-6" style={{ scrollMargin: '20px' }}>
          <h2 className="text-3xl md:text-4xl font-bold text-primary-dark mb-6 border-b-2 border-border-light pb-2 flex items-center">
            <Info className="w-7 h-7 mr-2" /> About Dilnavaz Mehta
          </h2>
          <div>
            <img className='float-right mx-4 w-2/5 object-cover rounded-lg shadow-lg'
              src={dmImageUrl}
              alt="Dilnavaz Mehta"
            />
            {aboutDmText.split('\n').map((line, index) => (
              <p key={index} className="text-lg text-text-dark">
                {line.trim() === '' ? <br /> : line}
              </p>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUsPage;
